export enum FinanceDashboardChartPresentationType {
    Amount = 'amount',
    Percentage = 'percentage'
}

export enum FinanceDashboardChartType {
    Pie = 'pie',
    Bar = 'bar'
}
    